<h1
	mat-dialog-title
	class="dialog-title m-0 fw-bold fs-4 pb-3a"
>
	{{ "rating.selector.title" | translate }}
</h1>
<mat-dialog-content>
	<div class="pt-3 cursor-pointer">
		<star-rating
			(ratingChange)="ratingChange($event)"
			[showHalfStars]="false"
			starType="svg"
			size="large"
			staticColor="ok"
			[numOfStars]="5"
			[rating]="0"
		>
		</star-rating>
	</div>
	<div class="text-center pt-3">
		<a
			[class.disabled]="!rated"
			(click)="vote()"
			class="btn btn-blue text-uppercase"
		>
			{{ "rating.selector.vote" | translate }}
		</a>
	</div>
</mat-dialog-content>